import * as React from 'react'
import { Dialog } from '../common/Dialog'
import { I18nCatalogue } from '../../i18n/auth/types'
import { resetPasswordRequest } from '../../types/resetPassword'
import { Input } from '../common/Input'
import { GlobalContext } from '../../globalContext'

interface Props {
  readonly catalogue: I18nCatalogue
  readonly onClose: () => void
}

interface State {
  readonly email: string
  readonly errorMessage?: string
}

export function InputEmailToResetPassword({ catalogue, onClose }: Props) {
  const [state, setState] = React.useState<State>({ email: '' })
  const { notifications, updateContext } = React.useContext(GlobalContext)
  const action = async () => {
    try {
      await resetPasswordRequest(state.email)
      onClose()
      updateContext(draft => {
        draft.notifications = [{ text: catalogue.signIn.passwordResetEmailSent }, ...notifications]
      })
    } catch (e) {
      console.log(e)
      setState({ ...state, errorMessage: catalogue.signIn.error.emailNotFound })
    }
  }

  return (
    <Dialog
      onClose={onClose}
      actions={[
        { label: catalogue.cancel, look: 'white' },
        { label: catalogue.signIn.sendPasswordResetEmail, look: 'primary', onClick: action },
      ]}>
      <p>{catalogue.signIn.enterYourEmailAddress}</p>
      <Input
        type="email"
        value={state.email}
        onChange={e => setState({ email: e.currentTarget.value })}
        fluid
        required
        onEnterKeyDown={action}
      />
    </Dialog>
  )
}
